export default __webpack_public_path__ + "static/media/board_collab_match.b54ddc8e.png";